import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { ChangesService } from './changes.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CanDeactivateChangesWarning implements CanDeactivate<any> {
    constructor(private readonly changesService: ChangesService) {}

    canDeactivate(
        component: any,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot
    ): Observable<boolean> | boolean {
        if (!this.changesService.hasChanges()) return true;
        return this.changesService.warn();
    }
}
